import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const Tooltip = styled.div<{ $width: number; $position: string; $onHover: boolean }>`
  position: absolute;
  opacity: 0;
  visibility: hidden;
  z-index: ${({ theme }) => theme.zIndex.x10};
  background: ${({ theme }) => theme.palette.secondary};
  border-radius: ${({ theme }) => theme.rounded.x8};
  padding: ${({ theme }) => `${theme.spacing.x1} ${theme.spacing.x2}`};
  transition: 0.1s ease-out;
  font-size: ${({ theme }) => theme.fs.xs};
  color: ${({ theme }) => theme.palette.white};
  text-align: center;
  transform: translateX(-50%);
  width: ${({ $width }) => $width + 'px'};
  &::before {
    z-index: -1;
    content: '';
    position: absolute;
    width: ${({ theme }) => theme.spacing.x4};
    height: ${({ theme }) => theme.spacing.x4};
    background: ${({ theme }) => theme.palette.secondary};
    display: block;
  }
  ${({ $onHover }) =>
    $onHover
      ? css`
          opacity: 1;
          visibility: visible;
        `
      : css`
          opacity: 0;
          visibility: hidden;
        `};
  ${({ $position }) =>
    $position === 'right'
      ? css`
          top: 50%;
          left: calc(100% + 10px);
          transform: translate(0, -50%);
          &::before {
            left: 5px;
            top: 50%;
            transform: translate(-50%, -50%) rotate(45deg);
          }
        `
      : $position === 'left'
      ? css`
          top: 50%;
          right: calc(100% + 10px);
          transform: translate(0, -50%);
          &::before {
            left: 5px;
            top: 50%;
            transform: translate(-50%, -50%) rotate(45deg);
          }
        `
      : $position === 'top'
      ? css`
          left: 50%;
          bottom: calc(100% + 5px);
          &::before {
            left: 50%;
            bottom: calc(0px + 5px);
            transform: translate(-50%, 50%) rotate(45deg);
          }
        `
      : css`
          left: 50%;
          top: calc(100% + 5px);
          &::before {
            left: 50%;
            top: calc(0px + 5px);
            transform: translate(-50%, 50%) rotate(45deg);
          }
        `};
`;
